import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // NOSONAR: ErrorBoundary logging is intentional for unhandled client-side runtime errors
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, errorInfo) // NOSONAR
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Something went wrong.</h2>
            <p>Please refresh the page or contact support if the problem persists.</p>
            <button onClick={() => window.location.reload()}>Refresh Page</button>
          </div>
        )
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
